import { Navigate } from "react-router-dom";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { VerifyEmail } from "../../../fakebackend_helper";
import { apiError, registerUserSuccessful } from "../register/reducer";
import axios from 'axios';




export const verifyEmail = (email, navigate)=> async (dispatch)=> {
    try {
        let response;
        response=VerifyEmail(email)
        var data = await response;

        if(data.data.status==="SUCCESS"){
            // navigate("")
            dispatch(registerUserSuccessful(data.data));
navigate("/page-forgot-password")
        }else{
            dispatch(apiError(data.data));
        }
    } catch (error) {
        console.log(error.response.data)
        dispatch(apiError(error.response.data));
    }

}

export const resetPassword = (newPassword, navigate) => async (dispatch) => {
    try {
      let response;
      let passwordResetSuccessful;
      let ResetPasswordAPI;

      response = ResetPasswordAPI(newPassword); 
      const data = await response; 
  
     
      if (data.data.status === "SUCCESS") {
        dispatch(passwordResetSuccessful(data.data)); 
        console.log("Mot de passe réinitialisé avec succès");
        navigate("/login"); 
        dispatch(apiError(data.data)); 
      }
    } catch (error) {
      console.log(error.response?.data || error.message);
      dispatch(apiError(error.response?.data || { message: "Erreur de connexion au serveur" }));
    }
  };

  export const resendPassword = (token, newPassword, confirmationPassword, navigate) => async (dispatch) => {
    try {
      const response = await axios.post(
        'http://95.111.225.198:8082/usersApi/api/auth/reset-password/confirm',
        {
          token,
          newPassword,
          confirmationPassword,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
  
      if (response.data.status === "SUCCESS") {
        dispatch({ type: 'PASSWORD_RESET_SUCCESS', payload: response.data });
        console.log("Mot de passe réinitialisé avec succès");
        navigate("/login"); // Redirige vers la page de connexion
      } else {
        dispatch({ type: 'PASSWORD_RESET_FAILURE', payload: response.data.message });
        console.error("Erreur lors de la réinitialisation du mot de passe :", response.data.message);
      }
    } catch (error) {
      console.error(error.response?.data || error.message);
      dispatch({ type: 'PASSWORD_RESET_FAILURE', payload: error.response?.data || { message: "Erreur de connexion au serveur" } });
    }
  };
